import { state } from '../lib/state.js';
import { startServerCalculatorJob } from '../services/server-calculator-bridge.js';
import { els } from '../app/dom.js';
import { requireAuthenticatedSession } from '../app/auth.js';
import { setStatus, sectionDistanceKm, formatDuration } from '../lib/app-helpers.js';
import { prepareSectionMetrics } from './common.js';

export async function runEtoll(section){
  if(!await requireAuthenticatedSession('uruchomić kalkulator e-TOLL'))return;

  const preparedSection=await prepareSectionMetrics(section,'polskiego');
  if(!preparedSection)return;

  const distanceKm=sectionDistanceKm(preparedSection);
  const durationText=Number.isFinite(Number(preparedSection.durationSeconds))?formatDuration(Number(preparedSection.durationSeconds)):'';
  const jobId=crypto.randomUUID();
  const payload={
    jobId,
    calculatorKey:'etoll-pl',
    routeId:state.currentRoute.id,
    routeVersionId:state.currentRoute.versionId,
    routeTitle:state.currentRoute.title,
    sourceFile:state.currentRoute.sourceFileName,
    countryCode:'PL',
    countryName:'Polska',
    sectionId:preparedSection.id,
    sectionOrder:preparedSection.order,
    distanceKm,
    durationText,
    points:preparedSection.points.map(p=>({name:p.name,address:p.address||'',countryCode:p.countryCode||'',countryName:p.countryName||'',country:p.countryName||'',type:p.isBorder?'Granica':'Przystanek',lat:p.lat,lon:p.lon,isBorder:p.isBorder,query:`${p.lat}, ${p.lon}`,searchQueries:[`${p.lat}, ${p.lon}`]})),
    settings:{emissionClass:'EURO 6',vehicleCategory:'Autobus powyżej 9 miejsc',variant:'fastest'}
  };

  setStatus(els.extensionStatus,`Wysyłam ${preparedSection.points.length} punktów na serwer e-TOLL…`,'working');
  try{
    await startServerCalculatorJob(payload,{organizationId:state.organizationId});
  }catch(error){
    console.error('[D24 SERVER CALCULATOR]',error);
    setStatus(els.extensionStatus,`Nie udało się wysłać zadania e-TOLL na serwer: ${error.message}`,'error');
  }
}

